<template>
  <div class="home page">
    <div class="banner embed-responsive text-center">
      <div class="cover">
        <span class="d-md-block">Witamy na stronie</span>
        <span>Parkingu Społecznego Kopcińskiego</span>
      </div>
      <div class="copyright">
        Zdjęcie:
        <a
          href="https://fshoq.com/pl/darmowe-zdjecia/p/38/warszawa-polska-panorama-miasta"
          target="_blank"
          ref="nofollow"
          >Fshoq!</a
        >
      </div>
    </div>

    <div class="container">
      <h2 class="h3 pb-2 mb-3 border-bottom">Aktualności</h2>

      <b-card
        title="Zaproszenie na Walne Zebranie Użytkowników"
        sub-title="13 kwietnia 2026"
        tag="article"
        class="mb-3"
      >
        <b-card-text>
          Społeczny Komitet Parkingowy zaprasza serdecznie na Walne Zebranie Użytkowników w dniu
          <b>23 kwietnia (czwartek), o godzinie 19:00</b>.<br />
          Zebranie odbędzie się w
          <a href="https://maps.app.goo.gl/gjUF53NTfrPKvYqr6" target="_blank"
            >Klubie Nugat, ul. Nugat 4.</a
          >
          Szczegółowe informacje w dziale
          <router-link :to="{ name: 'walne-2026' }">Walne Zebrania</router-link>.
        </b-card-text>
      </b-card>

      <b-card
        title="Podatek od nieruchomości oraz energia elektryczna za 2019"
        sub-title="21 luty 2020"
        tag="article"
        class="mb-3"
      >
        <b-card-text>
          Uprzejmie informujemy o konieczności wniesienia opłaty za podatek od nieruchomości oraz
          korzystanie z energii elektrycznej za rok 2019. Szczegółowe informacje w dziale
          <router-link :to="{ name: 'oplaty' }">Opłaty</router-link>.
        </b-card-text>
      </b-card>

      <b-card
        title="Raport z wykorzystania środków z funduszu społecznego"
        sub-title="6 stycznia 2020"
        tag="article"
        class="mb-3"
      >
        <b-card-text>
          Realizując postanowienia regulaminu (§1 pkt. 5.3) publikujemy
          <a href="/files/2020-01-05_fundusz_społeczny_wydatki.pdf" target="_blank"
            >aktualny raport z wykorzystania srodków z funduszu społecznego</a
          >. Skany potwierdzeń płatności zostaną opublikowane jak tylko uruchomimy na stronie moduł
          logowania.
        </b-card-text>
      </b-card>

      <b-card title="Modernizacja furtek" sub-title="5 stycznia 2020" tag="article" class="mb-3">
        <b-card-text>
          Uprzejmie informujemy, że zgodnie z
          <a href="/files/walne-2019/walne_uch.07.pdf" target="_blank"
            >uchwałą nr 7/2019 Walnego Zebrania Użytkowników</a
          >
          zrealizowaliśmy modernizację furtek parkingu.<br />
          Prace wykonaliśmy własnymi siłami i bez wynagrodzenia. Koszt materiałów został pokryty z
          funduszu społecznego.<br />
          Prace modernizacyjne wymagały tymczasowego doprowadzenia zasilania do furtek. Z tego
          względu zostały zakupione dwa przedłużacze 30m. Pozostają one do Państwa dyspozycji, np.
          na potrzeby odkurzania samochodu. Jeśli ktoś z Państwa będzie chciał z nich skorzystać,
          prosimy o kontakt.
        </b-card-text>
      </b-card>

      <b-card
        title="Podsumowanie Walnego Zebrania Użytkowników"
        sub-title="16 grudnia 2019"
        tag="article"
        class="mb-3"
      >
        <b-card-text>
          Zapraszamy do zapoznania się z
          <router-link :to="{ name: 'walne-2019' }">
            podsumowaniem Walnego Zebrania Użytkowników</router-link
          >, które odbyło się w dniu 13 grudnia 2019.
        </b-card-text>
      </b-card>

      <b-card
        title="Planowane poszerzenie miejsc w wewnętrznym pierścieniu"
        sub-title="4 grudnia 2019"
        tag="article"
        class="mb-3"
      >
        <b-card-text>
          Zapraszamy do zapoznania się z treścią
          <a href="/files/2019-12-04_uchwała_1_2019.pdf" target="_blank">
            uchwały 1/2019 Społecznego Komitetu Parkingowego z dnia 04.12.2019</a
          >
          w sprawie poszerzenia miejsc parkingowych w wewnętrznym pierścieniu.
        </b-card-text>
      </b-card>

      <b-card title="Legalność Komitetu" sub-title="2 grudnia 2019" tag="article">
        <b-card-text>
          Aby ostatecznie rozwiać wątpliwości dotyczące legalności Komitetu, wybranego na zebraniu
          19&nbsp;września 2019, zapraszamy do zapoznania się z
          <a href="/files/2019-11-29_odpowiedz_poparcie.pdf" target="_blank">
            pismem PU/1726/2019 z dnia 29.11.2019r</a
          >, które otrzymaliśmy od Spółdzielni.<br />
          <i>
            Podane w piśmie kwoty z tytułu podatku od nieruchomości i zużycia energii elektrycznej
            za rok 2018 są wartościami <u>łącznymi za cały parking</u>.
          </i>
        </b-card-text>

        <b-card-text class="font-weight-bold">
          Serdecznie dziękujemy za wsparcie oraz zaufanie, którym nas Państwo obdarzyli.
          Gwarantujemy, że nie zawiedziemy tego zaufania i pomimo trudności nadal działamy, aby nasz
          parking zapewniał odpowiedni komfort i bezpieczeństwo użytkowania.
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'home',
  components: {},
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.banner {
  background-size: cover;
  background-image: url('~@/assets/free-image-38-big.jpg');
  background-repeat: no-repeat;
  background-position: center 10%;
  margin-bottom: 2rem;

  &:before {
    padding-top: 40%;
    background-color: rgba(#fff, 0.1);
  }

  .cover {
    position: absolute;
    top: 20%;
    bottom: 20%;
    right: 15%;
    left: 15%;
    background-color: rgba(0, 0, 0, 0.65);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: calc(0.8rem + 1vw);
    padding: 5px 10px;
  }

  @include media-breakpoint-up(md) {
    &:before {
      padding-top: 25%;
    }

    .cover {
      top: 25%;
      bottom: 25%;
      right: 25%;
      left: 25%;
    }
  }

  @include media-breakpoint-up(lg) {
    &:before {
      padding-top: 20%;
    }

    .cover {
      top: 30%;
      bottom: 30%;
      right: 30%;
      left: 30%;
    }
  }

  .copyright {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 5px 10px;
    color: #fff;
    font-size: 10px;
    opacity: 0.9;
    a {
      color: #fff;
    }
  }
}
</style>
